import { GameData } from '@/features/games/shared/types/game-data';
import { PriceIncludingWildMembership, PromotionData } from '@/shared/types/prices';
import { getPriceByType } from '@/features/games/shared/helpers/get-price-by-type';
import { TrackViewItemParams } from '@/features/gtm/shared/helper/track-view-item';

function calcDiscount(price: number, originalPrice?: number): number | undefined {
  if (!originalPrice || originalPrice <= price) return undefined;
  return Math.round((originalPrice - price) * 100) / 100;
}

export const buyOptionToEcommerceParams = (
  buyOptionPrice: PriceIncludingWildMembership[],
  gameData: GameData,
  isWildMember: boolean,
  promotion?: PromotionData,
): TrackViewItemParams => {
  const memberPrice = getPriceByType(buyOptionPrice, 'member');
  const salePrice = getPriceByType(buyOptionPrice, 'sale');
  const standardPrice = getPriceByType(buyOptionPrice, 'price');
  let discountReason: 'sale' | 'membership' | 'promotion' | undefined = undefined;
  let discount = 0;
  let originalPrice = standardPrice?.value || 0;
  const currency = standardPrice?.currencyCode || 'USD';
  let price = standardPrice?.value || 0;
  if (isWildMember) {
    discountReason = 'membership';
    discount = calcDiscount(memberPrice?.value || 0, standardPrice?.value || 0) || 0;
    price = memberPrice?.value || 0;
  }
  if (salePrice?.value) {
    discountReason = 'sale';
    discount = calcDiscount(salePrice.value!, salePrice.previousValue!) || 0;
    price = salePrice.value;
    originalPrice = salePrice.previousValue!;
  }

  if (promotion?.promotionalPrices?.length) {
    const currentPromotionPrice = getPriceByType(promotion?.promotionalPrices, 'current');
    discountReason = 'promotion';
    discount = calcDiscount(currentPromotionPrice?.value || 0, standardPrice?.value || 0) || 0;
    price = currentPromotionPrice?.value || 0;
    originalPrice = standardPrice?.value || 0;
  }

  return {
    itemName: gameData.name,
    itemId: gameData.sku,
    categories: gameData.categories?.map((cat) => cat.name),
    variant: 'purchase',
    itemBrand: gameData.developer?.value || '',
    productType: 'download',
    discountReason: discountReason,
    discount,
    originalPrice,
    currency,
    price,
  };
};
